import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import type { SustainabilityTopic } from '@app/src/types/topicalRisk'
import { ONE_MINUTE_MS } from '@app/src/wf-constants'

interface UseSustainabilityTopicsResult {
  topics: SustainabilityTopic[]
  isLoading: boolean
  isError: boolean
}

/**
 * Fetches all sustainability topics (id, name, ESG area) with no extra includes.
 * Lighter than useProfileTopics, which eagerly loads assessment-template relations.
 */
export const useSustainabilityTopics = (): UseSustainabilityTopicsResult => {
  const { items, isLoading, isError } = useFetchCollectionWithPost<SustainabilityTopic>({
    key: [FetchKey.SustainabilityTopics],
    endpoint: endpoints.sustainabilityTopics,
    payload: { filter: [], include: [] },
    options: { staleTime: ONE_MINUTE_MS * 60 },
  })

  return { topics: items, isLoading, isError }
}

export default useSustainabilityTopics
